import React, { Component } from 'react';

import LineGraph from '../common/graphs/lineGraph';
import axiosInstance from '../../config/axiosConfig';
import { getUser } from '../../actions/session';
import { MULTI_STATS_LINE_GRAPH } from '../../config/rest_endpoints';
import { Notifications } from '../common/notification';
/**
 * MultiStats - Premium Call Statistics Chart
 *
 * Displays call statistics with a beautiful line chart
 * and animated summary cards.
 */
export class MultiStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dates: [],
      tcc: [],
      tcd: [],
      tdc: [],
      asr: [],
      acd: [],
      tccTotal: '',
      tcdTotal: '',
      tdcTotal: '',
      asrAvg: '',
      acdAvg: '',
      User: getUser(),
      date: new Date()
    };
    this.getAllStats = this.getAllStats.bind(this);
  }

  componentDidMount() {
    this.getAllStats();
  }

  getAllStats() {
    const { User } = this.state;
    if (!User || !User.id) return;
    var payload = {
      statsDur: 'day'
    };
    var userId = User.id;
    // Using axiosInstance which automatically adds auth header and handles 401 errors
    axiosInstance.post(`${MULTI_STATS_LINE_GRAPH}/${userId}/stats`, payload)
      .then((res) => {
        if (res) {
          const resp = res.data.data;
          console.log('respp :>> ', resp);
          const sumTCC = resp.totalCallCost.reduce((a, b) => a + b, 0);
          const sumTCD = resp.totalCallDuration.reduce((a, b) => a + b, 0);
          const sumTDC = resp.totalDialedCalls.reduce((a, b) => a + b, 0);

          const asrValues = resp.asr || [];
          const acdValues = resp.acd || [];
          const asrNonZero = asrValues.filter(v => v > 0);
          const acdNonZero = acdValues.filter(v => v > 0);
          const asrAvg = asrNonZero.length > 0 ? (asrNonZero.reduce((a, b) => a + b, 0) / asrNonZero.length).toFixed(2) : '0';
          const acdAvg = acdNonZero.length > 0 ? (acdNonZero.reduce((a, b) => a + b, 0) / acdNonZero.length).toFixed(2) : '0';

          this.setState({
            dates: resp.date,
            tcc: resp.totalCallCost,
            tcd: resp.totalCallDuration,
            tdc: resp.totalDialedCalls,
            asr: asrValues,
            acd: acdValues,
            tccTotal: sumTCC,
            tcdTotal: sumTCD,
            tdcTotal: sumTDC,
            asrAvg: asrAvg,
            acdAvg: acdAvg
          });
        }
      })
      .catch((err) => {
        // 401/JWT expiry is handled by axiosInstance interceptor
        if (err.response && err.response.status !== 401) {
          const alert = err.response;
          if (alert.data && alert.data.message !== 'invalid or expired jwt') {
            Notifications.notify(alert.data.message, 'Failed', 'error');
          }
        }
      });
  }

  render() {
    const { dates, tcc, tcd, asr, acd } = this.state;

    return (
      <div className="row" style={{ animation: 'fadeInUp 0.5s ease' }}>
        <div className="col-md-12">
          <div className="card" style={{ transition: 'transform 200ms ease' }}>

            {/* Card Header */}
            <div
              className="card-header header-elements-sm-inline"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '1.25rem 1.5rem'
              }}
            >
              <div>
                <h5
                  style={{
                    margin: 0,
                    fontWeight: 700,
                    fontSize: '1.0625rem',
                    color: 'var(--color-text)',
                    letterSpacing: '-0.02em'
                  }}
                >
                  Call Statistics
                </h5>
                <p
                  style={{
                    margin: 0,
                    fontSize: '0.8125rem',
                    color: 'var(--color-text-tertiary)',
                    marginTop: '2px'
                  }}
                >
                  Last 24 Hours
                </p>
              </div>
            </div>

            {/* Chart */}
            <div className="chart mb-2">
              <div style={{ padding: '1.5rem' }}>
                <LineGraph
                  width={700}
                  height={300}
                  title={'Cost'}
                  title1={'Minutes'}
                  title3={'ASR (%)'}
                  title4={'ACD (s)'}
                  x={dates}
                  y={tcc}
                  y1={tcd}
                  y3={asr}
                  y4={acd}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MultiStats;
